import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Box } from '@mui/material';
import { clearAuthData } from '../store/slices/authSlice';
import Loader from './Loader';

const ENGAGE_URL = process.env.REACT_APP_ENGAGE_URL ?? '/';

const Logout: React.FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clearAuthData());
    sessionStorage.clear();
    localStorage.clear();

    const params = new URLSearchParams(window.location.search);
    const returnTo = params.get('returnTo');

    // Double rAF: ensures the loader is painted before navigation starts.
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        window.location.href = returnTo ?? ENGAGE_URL;
      });
    });
  }, [dispatch]);

  return (
    <Box
      height="100vh"
      width="100vw"
      position="fixed"
      top={0}
      left={0}
    >
      <Loader />
    </Box>
  );
};

export default Logout;
